/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */
import {ActionTree} from 'vuex';
import {RootState} from '@/store/types';
import {MessageInterface, MessageStateInterface} from '@/store/modules/message/types';


export const actions: ActionTree<MessageStateInterface, RootState> = {

    /**
     * Update messages.
     *
     * @param {any} commit
     * @param {MessageInterface[]} newMessages
     */
    updateMessages({commit}: {commit: any}, newMessages: MessageInterface[]): void {
        commit('updateMessages', newMessages);
    },

};
